<template>
  <v-container fluid class="fill-height d-block">
    <div class="pa-2 fill-height d-flex flex-column">
      <div
        class="d-flex justify-space-around justify-sm-start align-center align-content-center align-self-sm-start form-buttons flex-column flex-sm-row flex-sm-nowrap fill-width"
      >
        <v-btn
          color="primary"
          depressed
          class="mb-3 me-3"
          @click="commissionModal = true"
        >
          {{ $t("panel.currencyManagementPage.updateDefaultCommission") }}
        </v-btn>

        <!--        <v-btn-->
        <!--          color="primary"-->
        <!--          depressed-->
        <!--          to="/panel/currency-management/add-currency"-->
        <!--          class="mb-3"-->
        <!--        >-->
        <!--          {{ $t("panel.currencyManagementPage.addCoin") }}-->
        <!--        </v-btn>-->
        <v-form
          @submit.prevent="filtersSubmission()"
          class="d-flex align-center mb-3 flex-column flex-sm-row justify-sm-space-between fill-width ps-sm-2"
        >
          <div class="d-flex justify-between flex-wrap">
            <v-autocomplete
              prepend-inner-icon="mdi-magnify"
              class="theme-custom-input input-search select-search crypto"
              v-model="filtersObj.currencyId"
              :items="cryptoCurrencyList.allItems"
              item-value="currencyId"
              item-text="iso"
              outlined
              :label="
                $t('panel.transactionPage.deposit.searchBoxesForm.crypto')
              "
              hide-details
              dense
              clearable
              :loading="cryptoCurrencyList.autocompleteListLoading"
              @focus="
                inputSearchCheck(
                  $event,
                  allCryptoCurrency,
                  'cryptoCurrencyList',
                  'iso'
                )
              "
              @keyup="
                inputSearch(
                  $event,
                  allCryptoCurrency,
                  'cryptoCurrencyList',
                  'iso'
                )
              "
              @paste="
                inputSearch(
                  $event,
                  allCryptoCurrency,
                  'cryptoCurrencyList',
                  'iso'
                )
              "
              @click:clear="
                inputSearch(
                  $event,
                  allCryptoCurrency,
                  'cryptoCurrencyList',
                  'iso'
                )
              "
            >
              <template v-slot:selection="{ item }">
                <div class="text-truncate">
                  {{ item.iso }} ({{ item.network }})
                </div>
              </template>
              <template v-slot:item="{ item }">
                {{ item.iso }} ({{ item.network }})
              </template>
              <template v-slot:append-item>
                <div
                  v-intersect.quiet="intersectIsoNetwork"
                  class="ms-4"
                  v-if="
                    !cryptoCurrencyList.moreItemsLoading &&
                      cryptoCurrencyList.displayMoreItem
                  "
                >
                  ...
                </div>
                <v-progress-circular
                  v-else-if="cryptoCurrencyList.moreItemsLoading"
                  :size="20"
                  :width="2"
                  color="primary"
                  indeterminate
                  class="d-block mx-auto"
                />
              </template>
            </v-autocomplete>
          </div>
          <div
            class="d-flex flex-sm-wrap justify-space-around align-center align-content-center align-self-sm-end form-buttons"
          >
            <v-btn depressed color="primary" class="ma-3 order-1" type="submit">
              {{ $t("panel.transactionPage.deposit.searchBoxesForm.submit") }}
            </v-btn>
            <v-btn outlined color="primary" @click="resetFilters">{{
              $t("panel.transactionPage.deposit.searchBoxesForm.reset")
            }}</v-btn>
          </div>
        </v-form>
      </div>
      <v-data-table
        fixed-header
        :headers="$t('panel.currencyManagementPage.table.headers')"
        :items="tableData"
        item-key="id"
        :loading="loading"
        loading-text="Loading... Please wait"
        :page.sync="filtersObj.page"
        :items-per-page="filtersObj.size"
        hide-default-footer
        @page-count="pageCount = $event"
        :class="shortList"
      >
        <template v-slot:item.logo="{ item }">
          <div class="d-flex align-center">
            <v-img
              contain
              :src="item.logoURL"
              width="28"
              height="auto"
              class="me-2"
            />
          </div>
        </template>

        <template v-slot:item.crypto="{ item }">
          <div class="d-flex align-center">
            <span class="me-1">{{ item.name }}</span>
            <span class="font-regular-12">({{ item.network }})</span>
          </div>
        </template>

        <template v-slot:item.percentage="{ item }">
          {{ item.percentage }}%
        </template>

        <template v-slot:item.isBitrahSupport="{ item }">
          <v-btn
            small
            text
            :color="item.isBitrahSupport ? 'success' : 'error'"
            :loading="tableFieldLoading[item.currencyId] || false"
            @click="openAvailabilityModal(item)"
            class="text-decoration-underline"
          >
            {{ item.isBitrahSupport }}
          </v-btn>
        </template>

        <template v-slot:item.isWalletManagerSupport="{ item }">
          <v-btn
            small
            text
            :color="item.isWalletManagerSupport ? 'success' : 'error'"
            :loading="tableFieldLoading[item.iso] || false"
            @click="openWalletSupportModal(item)"
            class="text-decoration-underline"
          >
            {{ item.isWalletManagerSupport }}
          </v-btn>
        </template>

        <template v-slot:item.actions="{ item }">
          <router-link
            :to="{
              name: 'currencySettings',
              params: { currencyId: item.currencyId }
            }"
            >{{
              $t("panel.currencyManagementPage.table.content.settings")
            }}</router-link
          >
        </template>
      </v-data-table>

      <div v-if="tableData.length" class="text-center pt-2">
        <v-pagination
          v-model="filtersObj.page"
          :length="totalPages"
          :total-visible="7"
          prev-icon="< Back"
          next-icon="Next >"
          class="pagination"
          @input="filtersSubmission(true)"
        ></v-pagination>
      </div>
    </div>

    <v-dialog v-model="availabilityModal" max-width="450px">
      <v-btn icon :ripple="false" @click="availabilityModal = false">
        <v-icon size="24">mdi-close</v-icon>
      </v-btn>

      <div class="pa-6 text-center">
        <div class="font-regular-14 mb-8">
          {{
            $t(
              "panel.currencyManagementPage.availabilityModal.sureToChangeAvailabilityStatusTo",
              { status: !selectedCurrency.isBitrahSupport }
            )
          }}
        </div>

        <div class="d-md-flex justify-md-space-between">
          <v-btn
            depressed
            outlined
            :block="$vuetify.breakpoint.mdAndDown"
            color="error"
            class="py-6 px-10 font-semiBold-16 mb-3 mb-md-0 dialog-btn"
            @click="changeAvailabilityStatus"
          >
            {{ $t("panel.currencyManagementPage.availabilityModal.confirm") }}
          </v-btn>

          <v-btn
            depressed
            :block="$vuetify.breakpoint.mdAndDown"
            outlined
            color="gray7"
            class="py-6 px-10 font-semiBold-16 dialog-btn"
            @click="availabilityModal = false"
          >
            {{ $t("panel.currencyManagementPage.availabilityModal.cancel") }}
          </v-btn>
        </div>
      </div>
    </v-dialog>

    <v-dialog v-model="walletSupportModal" max-width="450px">
      <v-btn icon :ripple="false" @click="walletSupportModal = false">
        <v-icon size="24">mdi-close</v-icon>
      </v-btn>

      <div class="pa-6 text-center">
        <div class="font-regular-14 mb-8">
          {{
            $t(
              "panel.currencyManagementPage.walletSupportModal.sureToChangeAvailabilityStatusTo",
              { status: !selectedCurrency.isWalletManagerSupport }
            )
          }}
        </div>

        <div class="d-md-flex justify-md-space-between">
          <v-btn
            depressed
            outlined
            :block="$vuetify.breakpoint.mdAndDown"
            color="error"
            class="py-6 px-10 font-semiBold-16 mb-3 mb-md-0 dialog-btn"
            @click="changeWalletSupportStatus"
          >
            {{ $t("panel.currencyManagementPage.walletSupportModal.confirm") }}
          </v-btn>

          <v-btn
            depressed
            :block="$vuetify.breakpoint.mdAndDown"
            outlined
            color="gray7"
            class="py-6 px-10 font-semiBold-16 dialog-btn"
            @click="walletSupportModal = false"
          >
            {{ $t("panel.currencyManagementPage.walletSupportModal.cancel") }}
          </v-btn>
        </div>
      </div>
    </v-dialog>

    <v-dialog v-model="commissionModal" max-width="450px">
      <v-btn icon :ripple="false" @click="commissionModal = false">
        <v-icon size="24">mdi-close</v-icon>
      </v-btn>

      <v-form ref="form" @submit.prevent="updateDefaultCommission" class="pa-6">
        <v-text-field
          v-model="commissionPercentage"
          :rules="rules"
          v-separator="{ dot: true }"
          required
          :label="
            $t(
              'panel.currencyManagementPage.commissionModal.commissionPercentage'
            )
          "
          filled
          dense
          class="theme-custom-input fill-width"
        >
        </v-text-field>

        <v-btn
          color="primary"
          class="py-6 font-semiBold-16 mt-1"
          depressed
          block
          :loading="submitLoading"
          type="submit"
        >
          {{ $t("panel.currencyManagementPage.commissionModal.submit") }}
        </v-btn>
      </v-form>
    </v-dialog>
  </v-container>
</template>

<script>
import { currenciesService } from "@/services";
import setFiltersQueries from "@/mixins/setFilters&Queries";
import autocompleteListLazyLoading from "@/mixins/autocompleteListLazyLoading";

export default {
  name: "currency-management",
  mixins: [setFiltersQueries, autocompleteListLazyLoading],
  data() {
    return {
      allCryptoCurrency: currenciesService.getAllCryptoCurrency,
      pageCount: 0,
      totalPages: 1,
      loading: false,
      shortList: false,
      submitLoading: false,
      tableFieldLoading: {},
      filtersObj: {
        page: 1,
        size: 10
      },
      tableData: [],
      selectedCurrency: {},
      availabilityModal: false,
      walletSupportModal: false,
      commissionModal: false,
      commissionPercentage: 0,
      rules: [
        v =>
          !!v ||
          this.$t("panel.currencyManagementPage.commissionModal.notEmpty"),
        v =>
          +v <= 100 ||
          this.$t(
            "panel.currencyManagementPage.commissionModal.notValidPercentage"
          )
      ],
      cryptoCurrencyList: {
        page: 1,
        size: 10,
        name: null,
        timeout: false,
        displayMoreItem: true,
        moreItemsLoading: false,
        autocompleteListLoading: false,
        allItems: []
      }
    };
  },
  async created() {
    await this.$setFiltersFromQuery();
    await this.filtersSubmission(true);
    this.callApiToSetFilters();
  },
  methods: {
    callApiToSetFilters() {
      if (this.filtersObj.currencyId) {
        this.getIsoInfo();
      } else {
        this.getCryptoCurrency();
      }
    },
    getCryptoCurrency() {
      const filters = {
        page: this.cryptoCurrencyList.page,
        size: this.cryptoCurrencyList.size
      };
      currenciesService.getAllCryptoCurrency(filters).then(response => {
        this.cryptoCurrencyList.allItems = response.data.data.content;
      });
    },
    intersectIsoNetwork() {
      this.cryptoCurrencyList.page++;
      this.cryptoCurrencyList.moreItemsLoading = true;
      this.getAllAutocompleteItems(
        this.allCryptoCurrency,
        "cryptoCurrencyList",
        "iso",
        false
      );
    },
    resetFilters() {
      for (let key in this.filtersObj) {
        this.filtersObj[key] = null;
      }
      this.filtersObj.page = 1;
      this.filtersObj.size = 10;
      this.date = [];
      this.filtersSubmission();
    },
    // resetFilters() {
    //   for (let key in this.filtersObj) {
    //     this.filtersObj[key] = null;
    //   }
    //   this.filtersObj.page = 1;
    //   this.filtersObj.size = this.itemsPerPage;
    //   this.updateQuery();
    // },
    // setFiltersFromQuery() {
    //   Object.entries(this.$route.query).reduce((acc, [key, val]) => {
    //     if (key === "page" || key === "size") {
    //       this.filtersObj[key] = +val;
    //     } else this.filtersObj[key] = val;
    //   }, {});
    // },
    // updateQuery() {
    //   let queryParams = Object.entries(this.filtersObj).reduce(
    //     (acc, [key, val]) => {
    //       if (!val) return acc;
    //       return { ...acc, [key]: val };
    //     },
    //     {}
    //   );
    //   this.$router.replace({ query: { ...queryParams } }, () => {});
    //   this.loadData(queryParams);
    // },
    async filtersSubmission(paginationButton) {
      await this.loadData(this.$setQueryFromFilters(paginationButton));
    },
    loadData(tableFilters) {
      this.loading = true;
      currenciesService
        .getAllCryptoCurrency(tableFilters)
        .then(response => {
          this.tableData = response.data.data.content;
          const tableDataLength = this.tableData.length;
          if (tableDataLength < 5 && tableDataLength > 0) {
            if (tableDataLength === 1) {
              this.shortList = "short-list-one-item";
            } else this.shortList = "short-list";
          } else this.shortList = "";
          this.totalPages = response.data.data.totalPages;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    openAvailabilityModal(currency) {
      this.selectedCurrency = currency;
      this.availabilityModal = true;
    },
    openWalletSupportModal(currency) {
      this.selectedCurrency = currency;
      this.walletSupportModal = true;
    },
    changeAvailabilityStatus() {
      this.tableFieldLoading[this.selectedCurrency.currencyId] = true;
      const model = {
        cryptoCurrencyId: this.selectedCurrency.currencyId,
        supported: !this.selectedCurrency.isBitrahSupport
      };
      currenciesService
        .changeAvailability(model)
        .then(res => {
          this.$toast.success(res.data.message);
          // this.updateQuery();
          this.filtersSubmission(true);
          this.availabilityModal = false;
        })
        .finally(() => {
          this.tableFieldLoading[this.selectedCurrency.currencyId] = false;
        });
    },
    changeWalletSupportStatus() {
      this.tableFieldLoading[this.selectedCurrency.iso] = true;
      const model = {
        cryptoCurrencyId: this.selectedCurrency.currencyId,
        supported: !this.selectedCurrency.isWalletManagerSupport
      };
      currenciesService
        .changeWalletSupport(model)
        .then(res => {
          this.$toast.success(res.data.message);
          // this.updateQuery();
          this.filtersSubmission(true);
          this.walletSupportModal = false;
        })
        .finally(() => {
          this.tableFieldLoading[this.selectedCurrency.iso] = false;
        });
    },
    updateDefaultCommission() {
      this.submitLoading = true;
      const model = {
        percentage: this.commissionPercentage
      };
      currenciesService
        .changeDefaultCommission(model)
        .then(res => {
          this.$toast.success(res.data.message);
          // this.updateQuery();
          this.filtersSubmission(true);
          this.commissionModal = false;
        })
        .finally(() => {
          this.submitLoading = false;
        });
    }
  }
};
</script>
<style scoped lang="scss">
@import "CurrencyManagementList";
</style>
